import { render, staticRenderFns } from "./ApplicantProjectEvents.vue?vue&type=template&id=5655c688&scoped=true&"
import script from "./ApplicantProjectEvents.vue?vue&type=script&lang=js&"
export * from "./ApplicantProjectEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5655c688",
  null
  
)

export default component.exports